import { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import styled from "styled-components";
import { formatInTimeZone } from 'date-fns-tz'
import EmploymentDetailsEdit from "./edit";
import Section, { ListItem } from "../section";
import { updateJobEmployeeDetail, getJobEmployementDetail } from 'services'
import { useToasts } from "react-toast-notifications";
import PermissionGate from "permissions/PermissionGate";

const Wrapper = styled.div`
.section-body{
    padding: 20px 45px;
    
    .list-item .title{
        width: 170px;
        display: inline-block;
        text-align: right;
    }
}
`;

const EmploymentDetails = ({ person, refreshEmployeeInfo, match, disabled }: any) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [loadingRequest, setLoadingRequest] = useState<boolean>(false);
  const { addToast } = useToasts();
  const [hireInfo, setJobInfo] = useState<any>([]);

  useEffect(() => {
    getJobEmployementDetail(match.params.id ?? person.id).then(res => {
      setJobInfo(res.data[0]);
    })
  }, [match.params.id])


  const handleEditSubmit = (data: any) => {
    setLoadingRequest(true);
    updateJobEmployeeDetail(data, person.id).then(res => {
      setLoadingRequest(false);
      person.employee_employment_detail = res.data;
      setJobInfo(res.data)
      addToast('Employment details successfully updated', {
        appearance: 'success',
        autoDismiss: true,
      })
      refreshEmployeeInfo()
      setIsOpen(false)
    }).catch(err => {
      setLoadingRequest(false);
      addToast(err.response.data.errors[0].message, {
        appearance: 'error',
        autoDismiss: true,
      })
    });
  }

  return (
    <Wrapper style={{ height: 'calc(100% - 15px)' }}>
      <PermissionGate action="edit" on="employment" shouldVisible properties={{ disabled: true }}>
        <Section title='Employement Details'
          withUpdate={false}
          withEdit={true}
          onEditClick={() => setIsOpen(true)}
          style={{ height: '100%' }}
          disabled={disabled}
        >

          <div className='section-body'>
            <ListItem title='Employee #' value={person.id} />
            <ListItem title='Hire Date' value={hireInfo?.hire_date ? formatInTimeZone(new Date(hireInfo.hire_date), 'UTC', 'P') : null} />
            <ListItem title='Probation End Date' value={hireInfo?.probation_end_date ? formatInTimeZone(new Date(hireInfo.probation_end_date), 'UTC', 'P') : null} />
            <ListItem title='Contract End Date' value={hireInfo?.contract_end_date ? formatInTimeZone(new Date(hireInfo.contract_end_date), 'UTC', 'P') : null} />
          </div>

          <EmploymentDetailsEdit
            isOpen={isOpen}
            user={person}
            jobData={person.active_job_detail}
            onModalClose={() => setIsOpen(false)}
            onSubmit={handleEditSubmit}
            loadingRequest={loadingRequest}
          />
        </Section>
      </PermissionGate>
    </Wrapper>
  );
};

export default withRouter(EmploymentDetails);
